// Chart for just 1 scenario
import React, { Component } from 'react';
import { connect } from 'react-redux';

import PieRow from '../pieRow';

import { getProjectedModalSplitByOwnerAndTypeSeries } from '../../store/selectors/modalSplit';
import { getNumProjectionYears, PROJECTION_START_YEAR } from '../../store/selectors';

// Given a particular year, return the projection
const buildSlices = (pieData) => {
  return [
    {
      "id": '3-wheel / Commercial',
      "value": pieData.autoRickshaw.commercial
    },
    {
      "id": '4-wheel / Commercial',
      "value": pieData.car.commercial
    },
    {
      "id": '4-wheel / Private',
      "value": pieData.car.private
    },
    {
      "id": '4-wheel / Public',
      "value": pieData.car.public
    },
    {
      "id": '2-wheel / Commercial',
      "value": pieData.twoWheel.commercial
    },
    {
      "id": '2-wheel / Private',
      "value": pieData.twoWheel.private
    },
    {
      "id": 'Public Transit / Commercial',
      "value": pieData.publicTransit.bus
    },
    {
      "id": 'Public Transit / Private',
      "value": pieData.publicTransit.metro
    },
  ];
}

class BaseScenarioChart extends Component {
  render() {

    const rawData = this.props.modalSplit;
    // hack for now
    const startSlices = buildSlices(rawData[0]);
    const endSlices = buildSlices(rawData.slice(-1)[0]);
    const currentYear = PROJECTION_START_YEAR;
    const projectionYear = currentYear + this.props.projectionYear;
    return (
      <PieRow
        startData={startSlices}
        endData={endSlices}
        title={this.props.title}
        startTitle={currentYear}
        endTitle={projectionYear}
        containerHeight={'350px'}
        hasLegend={this.props.hasLegend}
      />
    );
  }
}


const mapStateToProps = (state, props) => ({
  // todo... make this return them for each scenario!!
  modalSplit: getProjectedModalSplitByOwnerAndTypeSeries(state, props),
  projectionYear: getNumProjectionYears(state),
})

export default connect(
  mapStateToProps,
  null
)(BaseScenarioChart);



// WEBPACK FOOTER //
// ./src/components/resultsPane/scenarioChart.js